// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterContent_root__VNx5N"};